import { CamelCaseKeys } from '@uplift/types';
import { restClient } from '../../client';
import { BaseResponse, User } from '../../resources';

export type FeatureFlagName = (
  // TODO: cleanup unused feature flags enum and cleanup it in database
  | 'monthlyView'
  | 'optional_2fa_for_users'
  | 'invite_provider_as_admin'
  | 'zoc_doc'
  | 'zocdoc'
  | 'matchingManagement'
  | 'newProviderLayout'
  | 'psychiatry-beta'
  | 'AUTO_NONPAYMENT_DEACTIVATION_TOGGLE'
  | 'HIGHER_ED_MVP'
  | 'PDF_GENERATE'
  | 'ADMIN_INSURANCE_MARKETS'
  | 'PROVIDER_FINANCE_PAGE'
  | 'ONBOARDING_WELCOME_STEP_AB_TEST'
  | 'IN_APP_MESSAGING'
  | 'IN_APP_MESSAGING_ADMIN'
  | 'ADMIN_MESSAGING_REPORT'
  | 'USER_PUBLIC_ICS_SUBSCRIPTION'
  | 'SALESFORCE_CREDENTIALING_ENABLED'
  | 'PROVIDER_DOCUMENT_CENTER'
  | 'betterhelp_sso'
);


export const getFeatureFlags = async (checkImpersonated: boolean) =>
  restClient.rawRequest<{ data: Record<FeatureFlagName, boolean> }>('/api/v1/feature_flags', {
    params: {
      check_impersonated: checkImpersonated
    }
  });

export type FeatureFlagRecord = CamelCaseKeys<{
  id: string;
  flag_name: FeatureFlagName;
  active: boolean;
  created_at: string;
  updated_at: string;
}>;


export const adminGetFeatureFlagsList = async () =>
  restClient.request<{
    data: FeatureFlag[];
  }>('/api/v1/admin/feature_flags');


type FeatureFlag = {
  id: string;
  flag_name: FeatureFlagName;
  active: boolean;
  created_at: string;
  updated_at: string;
};

export const adminUpdateFeatureFlag = async (flagId: string, active: boolean) =>
  restClient.request<{
    data: FeatureFlag[];
  }>(`/api/v1/admin/feature_flags/${flagId}`, { method: 'PATCH', data: { active: active } });

export type UserFlagResponse = {
  user: User;
  active: boolean;
};

export const adminGetUsersWithFlag = async (flagName: FeatureFlagName) =>
  restClient.request<BaseResponse<UserFlagResponse[]>>(`/api/v1/admin/feature_flags/${flagName}/users`);

export const adminCreateUserFeatureFlag = (flagName: FeatureFlagName, userId: string, active: boolean) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'POST',
    data: {
      active
    }
  });

export const adminToggleUserFeatureFlag = (flagName: FeatureFlagName, userId: string, active: boolean) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'PATCH',
    data: {
      active
    }
  });

export const adminDeleteUserFeatureFlag = (flagName: FeatureFlagName, userId: string) =>
  restClient.request(`/api/v1/admin/feature_flags/${flagName}/users/${userId}`, {
    method: 'DELETE'
  });
